import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ade27aae&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ade27aae')) {
      api.createRecord('ade27aae', component.options)
    } else {
      api.reload('ade27aae', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ade27aae&", function () {
      api.rerender('ade27aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yBK0HhbOvTu0/JS/offershelp.vue"
export default component.exports